(function () {
  // Trailing-wildcard rewrite for the product-only catalog search
  // (snippets/catalog-search-form.liquid). Shopify's storefront /search does
  // prefix matching when a term ends in "*", so "frog*" matches "frogs" and
  // "gala*" matches "Galaxy". We append "*" to each term at submit time
  // rather than baking it into the input, so the shopper types a clean word
  // and still gets forgiving matching. The results page
  // (sections/main-search.liquid) strips the "*" back out of the heading and
  // the pre-filled box, so the wildcard is invisible end to end — it only
  // ever lives in the URL's q= param, where Shopify needs it.
  //
  // Delegated on document (one listener, any number of forms) and guarded so
  // including the script from more than one section on a page can't double
  // bind. Multi-word queries stay AND, just each side prefix-matched
  // ("galaxy* frog*"), so "gala frog" still finds "Galaxy ... Frogs".
  if (window.__catalogSearchWildcardBound) return;
  window.__catalogSearchWildcardBound = true;

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains("catalog-search")) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var raw = input.value.trim();
    // Nothing to match on, or a quoted exact-phrase search ("galaxy frogs") —
    // appending "*" inside quotes would break the phrase, so leave it alone.
    if (!raw || raw.indexOf('"') !== -1) return;

    input.value = raw
      .split(/\s+/)
      .map(function (term) {
        return term.charAt(term.length - 1) === "*" ? term : term + "*";
      })
      .join(" ");
  });
})();
